<div class="wrapper fadeInDown">
  <div class="formContent">
    <!-- Tabs Titles -->
    <a routerLink="/">Regresar</a>

    <h2 class="active">Inicia Sesión</h2>

    <!-- Icon -->
    <div class="fadeIn first">
      <img loading="lazy"
        src="https://static.vecteezy.com/system/resources/thumbnails/005/545/335/small/user-sign-icon-person-symbol-human-avatar-isolated-on-white-backogrund-vector.jpg"
        id="icon" alt="User Icon" />
    </div>

    <!-- Login Form -->
    <form [formGroup]="formSend">
      <input formControlName="user" type="text" id="login" class="fadeIn second" placeholder="login" />
      @if (ctlForm.user.errors?.pattern) {
      <div class="invalid-message">
        Caracteres inválidos
      </div>
      }
      <input formControlName="pass" type="password" id="password" class="fadeIn third" placeholder="password" />
      @if (ctlForm.pass.errors?.pattern) {
      <div class="invalid-message">
        Caracteres inválidos
      </div>
      }
      <app-btn-normal (click)="sendInfo()" class="fadeIn fourth" [contentBtn]="'Ingresar'"
        [typeBtn]="formSend.invalid ? 'button' : 'submit'"></app-btn-normal>
    </form>


    <!-- Remind Passowrd -->
    <div class="formFooter">
      <a class="underlineHover" href="#">¿Olvidaste tu contraseña?</a>
    </div>


  </div>
</div>